import { FunctionComponent, useState } from 'react';
import * as vp from 'vopay';
import { convertToOptions } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI';

const { Box, Select, TextField } = vp;

type SearchValues = { searchTerm: string; country: string };

type SearchAccountsProps = {
  countries: string[];
  onSearch: (values: SearchValues) => void;
};

type FC = FunctionComponent<SearchAccountsProps>;

const SubAccountSearchForm: FC = ({ countries, onSearch }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.SubAccounts.SearchForm' });
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');

  const countryObject = Object.fromEntries(
    countries.map((curr) => {
      if (curr === '') {
        return ['', 'All '];
      }
      return [curr, curr];
    }),
  ) as { [key: string]: string };

  const countryOptions = {
    '': 'Select Country',
    ...countryObject,
  };

  const handleSearch = () => {
    onSearch({ searchTerm, country });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
      <Box width="150px">
        <Select
          version="2"
          placeholder={t('countryPlaceholder')}
          options={convertToOptions(countryOptions)}
          name="country"
          onBlur={() => {}}
          onChange={(e) => setCountry(e.target.value)}
          value={country}
        />
      </Box>
      <TextField
        key="Keyword"
        name="keyword"
        placeholder={t('keywordPlaceholder')}
        variant="outlineShadow"
        onBlur={() => {}}
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
      />
      <Button id="sub-accounts-search" type="button" colorScheme="primary" size="small" onClick={handleSearch}>
        {t('searchButton')}
      </Button>
    </div>
  );
};

export default SubAccountSearchForm;
